<!--  -->
<template>
  <div class="coupon-page">
    <div class="header">
      <div class="ht">
        <img class="span-logo" src="../assets/imgs/LOGO_STEFANO_RICCI.svg" alt />
        <!-- <img class="logo" src="../assets/imgs/sr-logo.png" alt /> -->
      </div>
      <div class="nav">
        <div class="one-nav" :class="activeNav == 0 ? 'active-nav': ''" @click="changeActiveNav(0)">
          <div>可使用</div>
        </div>
        <div class="one-nav" :class="activeNav == 1 ? 'active-nav': ''" @click="changeActiveNav(1)">
          <div>已使用</div>
        </div>
        <div class="one-nav" :class="activeNav == 2 ? 'active-nav': ''" @click="changeActiveNav(2)">
          <div>已过期</div>
        </div>
      </div>
    </div>

    <div class="list" v-if="activeNav == 0">
      <div
        class="coupon-box"
        v-if="couponList0.length"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="noData0"
        infinite-scroll-distance="0"
      >
        <div class="one-coupon" v-for="(item, index) in couponList0" :key="index">
          <div class="coupon-top">
            <div class="coupon-left">
              <div class="cl-top">
                <div class="clt-left" @click="showCouponDetail(index)">
                  <img src="../assets/imgs/sr-logo.png" alt />
                </div>
                <div class="clt-right" @click="getCouponMsg(item.couponCode)">
                  <div class="coupon-name ellipsis">{{item.faceValue}}元</div>
                  <div class="coupon-date">{{item.startDate}}至{{item.endDate}}</div>
                  <div class="coupon-surplus" v-if="item.usageType == 1">
                    满<span class="font-bold">{{item.money}}</span>元可用
                    <span class="use-type">单次使用</span>
                  </div>
                  <div class="coupon-surplus" v-if="item.usageType == 2">
                    余额<span class="font-bold">{{item.leftoverValue}}</span>元
                    <span class="use-type">多次使用</span>
                  </div>
                </div>
              </div>
              <div class="cl-bottom" @click="showCouponDetail(index)">
                <span>详细信息</span>
                <span class="arrow" v-if="item.couponShow">︿</span>
                <span class="arrow1" v-else>﹀</span>
              </div>
            </div>
            <div class="coupon-right">
              <img
                class="status-img"
                src="../assets/imgs/erweima.png"
                alt
                @click="getCouponMsg(item.couponCode, 0)"
              />
              <div class="round"></div>
              <div class="round round2"></div>
            </div>
          </div>
          <div class="coupon-detail" v-if="item.couponShow">
            <p>{{item.couponName}}</p>
            <p v-if="item.info != null">使用说明: {{item.info}}</p>
            <p v-if="item.useRange == 1">使用门店：仅限大陆所有门店使用</p>
            <p v-if="item.useRange == 2">
              使用门店：
              <span v-for="(iitem, iindex) in item.couponShops" :key="iindex">
                {{iitem.shopName}}
                <i v-if="iindex+1 != item.couponShops.length">,</i>
              </span>
            </p>
            <!-- <p>优惠券编号: {{item.couponCode}}</p>
            <p v-if="item.getType == 1 || item.getType == 2">系统赠送优惠券</p>
            <p v-if="item.getType == 3">订单消费赠送优惠券</p>-->
          </div>
        </div>
      </div>

      <div class="empty" v-else>
        <img class="empty-img" src="../assets/imgs/sr-logo-gray.png" alt />
        <div>暂无优惠券</div>
      </div>
    </div>

    <div class="list" v-if="activeNav == 1">
      <div
        class="coupon-box"
        v-if="couponList1.length"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="noData1"
        infinite-scroll-distance="0"
      >
        <div class="one-coupon canot-use" v-for="(item, index) in couponList1" :key="index">
          <div class="coupon-top">
            <div class="coupon-left">
              <div class="cl-top">
                <div class="clt-left" @click="showCouponDetail(index)">
                  <img src="../assets/imgs/sr-logo-gray.png" alt />
                </div>
                <div class="clt-right" @click="getCouponMsg(item.couponCode)">
                  <div class="coupon-name ellipsis">{{item.faceValue}}元</div>
                  <div class="coupon-date">{{item.startDate}}至{{item.endDate}}</div>
                  <div class="coupon-surplus" v-if="item.usageType == 1">
                    满<span class="font-bold">{{item.money}}</span>元可用
                    <span class="use-type">单次使用</span>
                  </div>
                  <div class="coupon-surplus" v-if="item.usageType == 2">
                    余额<span class="font-bold">{{item.leftoverValue}}</span>元
                    <span class="use-type">多次使用</span>
                  </div>
                </div>
              </div>
              <div class="cl-bottom" @click="showCouponDetail(index)">
                <span>详细信息</span>
                <span class="arrow" v-if="item.couponShow">︿</span>
                <span class="arrow1" v-else>﹀</span>
              </div>
            </div>
            <div class="coupon-right">
              <img
                class="status-img"
                src="../assets/imgs/shiyong.png"
                alt
                @click="getCouponMsg(item.couponCode)"
              />
              <!-- <div class="use-now">立即使用</div> -->
              <div class="round"></div>
              <div class="round round2"></div>
            </div>
          </div>
          <div class="coupon-detail" v-if="item.couponShow">
            <p>{{item.couponName}}</p>
            <p v-if="item.info != null">使用说明: {{item.info}}</p>
            <p v-if="item.useRange == 1">使用门店：仅限大陆所有门店使用</p>
            <p v-if="item.useRange == 2">
              使用门店：
              <span v-for="(iitem, iindex) in item.couponShops" :key="iindex">
                {{iitem.shopName}}
                <i v-if="iindex+1 != item.couponShops.length">,</i>
              </span>
            </p>
            <!-- <p>优惠券编号: {{item.couponCode}}</p>
            <p v-if="item.getType == 1 || item.getType == 2">系统赠送优惠券</p>
            <p v-if="item.getType == 3">订单消费赠送优惠券</p>-->
          </div>
        </div>
      </div>

      <div class="empty" v-else>
        <img class="empty-img" src="../assets/imgs/sr-logo-gray.png" alt />
        <div>暂无优惠券</div>
      </div>
    </div>

    <div class="list" v-if="activeNav == 2">
      <div
        class="coupon-box"
        v-if="couponList2.length"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="noData2"
        infinite-scroll-distance="0"
      >
        <div class="one-coupon canot-use" v-for="(item, index) in couponList2" :key="index">
          <div class="coupon-top">
            <div class="coupon-left">
              <div class="cl-top">
                <div class="clt-left" @click="showCouponDetail(index)">
                  <img src="../assets/imgs/sr-logo-gray.png" alt />
                </div>
                <div class="clt-right" @click="getCouponMsg(item.couponCode)">
                  <div class="coupon-name ellipsis">{{item.faceValue}}元</div>
                  <div class="coupon-date">{{item.startDate}}至{{item.endDate}}</div>
                 <div class="coupon-surplus" v-if="item.usageType == 1">
                    满<span class="font-bold">{{item.money}}</span>元可用
                    <span class="use-type">单次使用</span>
                  </div>
                  <div class="coupon-surplus" v-if="item.usageType == 2">
                    余额<span class="font-bold">{{item.leftoverValue}}</span>元
                    <span class="use-type">多次使用</span>
                  </div>
                </div>
              </div>
              <div class="cl-bottom" @click="showCouponDetail(index)">
                <span>详细信息</span>
                <span class="arrow" v-if="item.couponShow">︿</span>
                <span class="arrow1" v-else>﹀</span>
              </div>
            </div>
            <div class="coupon-right">
              <img
                class="status-img"
                src="../assets/imgs/guoqi.png"
                alt
                @click="getCouponMsg(item.couponCode)"
              />
              <div class="round"></div>
              <div class="round round2"></div>
            </div>
          </div>
          <div class="coupon-detail" v-if="item.couponShow">
            <p>{{item.couponName}}</p>
            <p v-if="item.info != null">使用说明: {{item.info}}</p>
            <p v-if="item.useRange == 1">使用门店：仅限大陆所有门店使用</p>
            <p v-if="item.useRange == 2">
              使用门店：
              <span v-for="(iitem, iindex) in item.couponShops" :key="iindex">
                {{iitem.shopName}}
                <i v-if="iindex+1 != item.couponShops.length">,</i>
              </span>
            </p>
            <!-- <p>优惠券编号: {{item.couponCode}}</p>
            <p v-if="item.getType == 1 || item.getType == 2">系统赠送优惠券</p>
            <p v-if="item.getType == 3">订单消费赠送优惠券</p>-->
          </div>
        </div>
      </div>
      <div class="empty" v-else>
        <img class="empty-img" src="../assets/imgs/sr-logo-gray.png" alt />
        <div>暂无优惠券</div>
      </div>
    </div>

    <div class="footer">
      <img class="avatar" :src="memberMsg.img" alt />
      <div>会员编号：{{memberMsg.rpId}}</div>
    </div>

    <div class="modal" v-if="modalName == 'couponModal'">
      <div class="dialog">
        <div class="nav">
          <div
            v-if="chooseCouponMsg.useStatus == 0"
            class="one-nav"
            :class="modalNav == 0 ? 'active-nav': ''"
            @click="changeModalNav(0)"
          >
            <div>二维码</div>
          </div>
          <div class="one-nav" :class="modalNav == 1 ? 'active-nav': ''" @click="changeModalNav(1)">
            <div>使用记录</div>
          </div>
        </div>
        <div class="ewm-content" v-if="modalNav == 0">
          <img class="ewm" :src="ewmSrc" @load="ewmLoaded" alt />
          <div class="time" v-if="ewmSrc != ''">{{chooseCouponMsg.overTime}} 前有效</div>
        </div>
        <div class="record-content" v-if="modalNav == 1">
          <div v-if="chooseCouponMsg.couponRecords.length">
            <div
              class="one-record"
              v-for="(item, index) in chooseCouponMsg.couponRecords"
              :key="index"
            >
              <div>使用时间：{{item.useTime}}</div>
              <div>店铺：{{item.shopName}}</div>
              <div>店员账号：{{item.clerkName}}</div>
              <div v-if="item.usageType == 2">优惠券金额：{{item.faceValue}}</div>
              <div v-if="item.usageType == 2">核销金额：{{item.money}}</div>
              <div v-if="item.usageType == 2">余额金额：{{item.leftoverValue}}</div>
            </div>
          </div>

          <div class="empty" v-else>
            <img class="empty-img" src="../assets/imgs/sr-logo-gray.png" alt />
            <div>暂无使用记录</div>
          </div>
        </div>
        <div class="btn-wrapper">
          <button class="btn btn1" @click="hideModal">关闭</button>
          <button class="btn border-left" v-if="modalNav == 0" @click="getEwmSrc">刷新</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../assets/js/api.js";
import { baseUrl } from "../assets/js/api.js";
import util from "../assets/js/util.js";
import wx from "weixin-js-sdk";
import wxApi from "../assets/js/wxapi";
var that;
export default {
  data() {
    return {
      // 优惠券菜单
      activeNav: 0,
      noData0: false,
      noData1: false,
      noData2: false,
      pageIndex0: 0,
      pageIndex1: 0,
      pageIndex2: 0,
      pageSize: 10,
      // 优惠券列表
      couponList0: [],
      couponList1: [],
      couponList2: [],
      // 弹出框菜单
      modalNav: 0,
      // 使用记录
      recordList: [],
      // 弹出框名称
      modalName: null, // 展示优惠券弹层
      chooseCouponMsg: {}, // 选中优惠券的信息
      ewmSrc: "",
      needRefresh: false // 是否需要刷新页面
    };
  },

  components: {},

  computed: {},
  created() {
    that = this;
    that.memberMsg = JSON.parse(util.getss("memberMsg"));
  },

  mounted() {
    that.loadMore();
  },

  methods: {
    // 重置数据
    resetData() {
      // that.activeNav = 0;
      that.noData0 = false;
      that.noData1 = false;
      that.noData2 = false;
      that.pageIndex0 = 0;
      that.pageIndex1 = 0;
      that.pageIndex2 = 0;
      that.pageSize = 10;
      // 优惠券列表
      that.couponList0 = [];
      that.couponList1 = [];
      that.couponList2 = [];
      // 弹出框菜单
      that.modalNav = 0;
      // 使用记录
      that.recordList = [];
      // 弹出框名称
      that.modalName = null; // 展示优惠券弹层
      that.chooseCouponMsg = {}; // 选中优惠券的信息
      that.ewmSrc = "";
      // that.needRefresh = false; // 是否需要刷新页面
      that.loadMore();
    },
    // 获取列表
    loadMore() {
      // 判断是否还有数据
      if (that.activeNav == 0 && !that.noData0) {
        that.pageIndex0++;
        that.getList();
      }
      if (that.activeNav == 1 && !that.noData1) {
        that.pageIndex1++;
        that.getList();
      }
      if (that.activeNav == 2 && !that.noData2) {
        that.pageIndex2++;
        that.getList();
      }
    },
    getList() {
      let pageIndex;
      if (that.activeNav == 0) {
        pageIndex = that.pageIndex0;
        that.noData0 = true;
      } else if (that.activeNav == 1) {
        pageIndex = that.pageIndex1;
        that.noData1 = true;
      } else if (that.activeNav == 2) {
        pageIndex = that.pageIndex2;
        that.noData2 = true;
      }
      that.$http
        .get(api.getMemberConponByType, {
          params: {
            token: util.getss("token"),
            pageIndex: pageIndex,
            type: that.activeNav
          }
        })
        .then(res => {
          if (res.code === util.ERR_OK) {
            if (that.activeNav == 0) {
              that.couponList0 = that.couponList0.concat(res.data);
              if (res.data.length < that.pageSize) {
                that.noData0 = true;
              } else {
                that.noData0 = false;
              }
            } else if (that.activeNav == 1) {
              that.couponList1 = that.couponList1.concat(res.data);
              if (res.data.length < that.pageSize) {
                that.noData1 = true;
              } else {
                that.noData1 = false;
              }
            } else if (that.activeNav == 2) {
              that.couponList2 = that.couponList2.concat(res.data);
              if (res.data.length < that.pageSize) {
                that.noData2 = true;
              } else {
                that.noData2 = false;
              }
            }
          } else {
            that.$toast({ message: res.msg, duration: 2000 });
          }
        });
    },
    // 切换优惠券菜单
    changeActiveNav(e) {
      that.activeNav = e;
      if (that.needRefresh) {
        that.resetData();
      } else {
        that.loadMore();
      }
    },
    // 切换优惠券弹层菜单
    changeModalNav(e) {
      if (e == 0 && that.ewmSrc == "") {
        that.getEwmSrc();
      }
      that.modalNav = e;
    },
    // 获取单张优惠券信息
    getCouponMsg(code, modalNav = 1) {
      that.chooseCouponMsg.couponCode = code;
      that.$http
        .get(api.getMemberOpenCoupon, {
          params: {
            token: util.getss("token"),
            couponCode: code
          }
        })
        .then(res => {
          if (res.code === util.ERR_OK) {
            that.chooseCouponMsg = res.data;
            if (res.data.useStatus == 0) {
              if (modalNav == 0) {
                that.modalNav = 0;
                that.getEwmSrc();
              } else {
                that.modalNav = 1;
                that.showModal("couponModal");
              }
            } else {
              that.modalNav = 1;
              that.showModal("couponModal");
            }
          } else {
            that.$toast({ message: res.msg, duration: 2000 });
          }
        });
    },
    // 获取二维码图片
    getEwmSrc() {
      that.needRefresh = true;
      let latitude;
      let longitude;
      // 是否需要判断定位 1 需要 2 不需要
      // alert(that.chooseCouponMsg.plaseSwitch);
      if (that.chooseCouponMsg.plaseSwitch == 2) {
        latitude = "31.192612"; // 纬度，浮点数，范围为90 ~ -90
        longitude = "121.420271"; // 经度，浮点数，范围为180 ~ -180。
        that.$http
          .get(api.getQRcode, {
            params: {
              couponCode: that.chooseCouponMsg.couponCode,
              latitude: latitude,
              longitude: longitude,
              token: util.getss("token")
            }
          })
          .then(res => {
            console.log(res);
            if (res.code === util.ERR_OK) {
              that.showModal("couponModal");
              that.ewmSrc = "data:image/jpeg;base64," + res.data.byte;
              that.chooseCouponMsg.overTime = res.data.overTime;
            } else {
              that.$toast({ message: res.msg, duration: 2000 });
            }
          });
      } else {
        if (wxApi.ready) {
          wx.getLocation({
            type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function(res) {
              latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
              longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
              that.$http
                .get(api.getQRcode, {
                  params: {
                    couponCode: that.chooseCouponMsg.couponCode,
                    latitude: latitude,
                    longitude: longitude,
                    token: util.getss("token")
                  }
                })
                .then(res => {
                  console.log(res);
                  if (res.code === util.ERR_OK) {
                    that.showModal("couponModal");
                    that.ewmSrc = "data:image/jpeg;base64," + res.data.byte;
                    that.chooseCouponMsg.overTime = res.data.overTime;
                  } else {
                    that.$toast({ message: res.msg, duration: 2000 });
                  }
                });
            },
            fail: function(res) {
              that.$toast(JSON.stringify(res));
            }
          });
        } else {
          that.$toast({ message: "请稍候", duration: 2000 });
        }
      }
    },
    ewmLoaded() {
      that.$indicator.close();
    },
    // 展示优惠券详情
    showCouponDetail(index) {
      if (that.activeNav == 0) {
        that.couponList0[index].couponShow = !that.couponList0[index]
          .couponShow;
      } else if (that.activeNav == 1) {
        that.couponList1[index].couponShow = !that.couponList1[index]
          .couponShow;
      } else if (that.activeNav == 2) {
        that.couponList2[index].couponShow = !that.couponList2[index]
          .couponShow;
      }
    },
    // 点击优惠券
    showModal(e) {
      that.modalName = e;
    },
    // 隐藏优惠券弹层
    hideModal() {
      if (that.needRefresh) {
        that.resetData();
      } else {
        that.modalName = null;
      }
    }
  }
};
</script>
<style lang='stylus' scoped>
// @import url('../assets/stylus/common/header.styl');
.coupon-page {
  width: 100vw;
  height: 100vh;
  background: #eee;
  overflow-y: scroll;

  .nav {
    padding: unit(10px) unit(30px);
    display: flex;
    align-items: center;
    background: var(--black);

    .one-nav {
      flex: 1;

      div {
        width: unit(150px);
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: unit(32px);
        color: #ffffff;
        height: unit(70px);
      }
    }

    .active-nav {
      div {
        font-size: unit(36px);
        color: var(--gold);
        border-bottom: unit(8px) solid var(--gold);
      }
    }
  }

  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: var(--black);
    z-index: 10;

    .ht {
      padding: unit(30px) unit(30px) unit(30px);
      display: flex;
      justify-content: center;
      align-items: center;

      .span-logo {
        height: unit(50px);
      }

      .logo {
        height: unit(100px);
      }
    }
  }

  .list {
    // padding: unit(270px) unit(20px) unit(140px);
    padding: unit(220px) unit(20px) unit(140px);

    // 没有优惠券
    .empty {
      width: 100%;
      padding: unit(100px);
      text-align: center;

      .empty-img {
        width: unit(450px);
        margin-bottom: unit(30px);
      }

      div {
        font-size: unit(40px);
        color: #999;
      }
    }

    /* 优惠券盒子 */
    .coupon-box {
      width: 100%;

      .one-coupon {
        width: 100%;
        background: #f6f6f6;
        border-radius: unit(14px);
        margin-bottom: unit(20px);

        .coupon-top {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: stretch;

          .coupon-left {
            flex: 1;
            background: #fff;
            display: flex;
            flex-direction: column;
            border-radius: unit(8px);

            .cl-top {
              padding: unit(10px) 0;
              flex: 1;
              display: flex;
              justify-content: space-between;
              align-items: center;

              .clt-left {
                width: unit(160px);
                height: 100%;
                border-right: 1px dashed #eee;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                  width: unit(120px);
                  height: unit(120px);
                }
              }

              .clt-right {
                flex: 1;
                padding: 0 unit(10px) 0 unit(30px);
                border-radius: unit(10px);

                .coupon-name {
                  width: unit(320px);
                  font-size: unit(38px);
                  font-weight: bold;
                  color: #2a3040;
                  margin-bottom: unit(8px);
                }

                .coupon-date, .coupon-surplus {
                  font-size: unit(22px);
                  color: #787e9a;

                  .use-type {
                    // color: var(--gold);
                  }

                  .font-bold {
                    font-weight: bold;
                    color: #2a3040;
                  }
                }

                .coupon-date {
                  margin-bottom: unit(4px);
                }
              }
            }

            .cl-bottom {
              width: 100%;
              height: unit(45px);
              border-top: 1px solid #eee;
              padding: 0 unit(20px) 0 unit(28px);
              display: flex;
              justify-content: space-between;
              align-items: center;

              span {
                font-size: unit(22px);
                color: #a9a9a9;
              }

              .arrow {
                margin-top: unit(-14px);
              }
            }
          }

          /* 右侧立即使用 */
          .coupon-right {
            width: unit(197px);
            height: unit(203px);
            background: var(--gold);
            position: relative;
            border-radius: unit(8px);

            .use-now {
              border-radius: unit(24px);
              border: unit(2px) solid #fff;
              width: unit(156px);
              height: unit(50px);
              font-size: unit(24px);
              color: #fff;
              span-align: center;
              line-height: unit(50px);
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              margin: auto;
            }

            .status-img {
              width: unit(140px);
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              margin: auto;
            }

            .round {
              width: unit(26px);
              height: unit(26px);
              background: #eee;
              border-radius: 50%;
              position: absolute;
              left: unit(-13px);
              bottom: unit(-13px);
            }

            .round2 {
              top: unit(-13px);
            }
          }
        }

        /* 下方详情 */
        .coupon-detail {
          padding: unit(22px) unit(22px) unit(12px);
          background: #f6f6f6;
          font-size: unit(22px);
          color: #a9a9a9;
          line-height: unit(32px);
          border-bottom-left-radius: unit(8px);
          border-bottom-right-radius: unit(8px);
          position: relative;
        }
      }

      .canot-use {
        .clt-right {
          div, span {
            color: #a9a9a9 !important;
          }
        }

        .coupon-right {
          background: #ccc !important;
        }
      }
    }
  }

  .footer {
    position: fixed;
    left: unit(20px);
    bottom: unit(30px);
    background: var(--black);
    height: unit(100px);
    padding: 0 unit(30px);
    border-radius: unit(50px);
    display: flex;
    align-items: center;

    .avatar {
      width: unit(80px);
      height: unit(80px);
      border-radius: 50%;
      margin-right: unit(20px);
    }

    div {
      color: var(--gold);
    }
  }

  .modal {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1000;

    .dialog {
      width: unit(600px);
      height: unit(900px);
      background: #fff;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;

      .nav {
        padding: unit(20px) unit(30px) unit(10px);
        height: unit(100px);
      }

      .ewm-content {
        text-align: center;
        padding: unit(30px);
        height: unit(720px);

        .ewm {
          width: unit(400px);
          height: unit(400px);
          margin: unit(100px) 0 unit(40px);
        }

        .time {
          font-size: unit(30px);
          color: var(--gray);
        }
      }

      .record-content {
        height: unit(720px);
        padding: unit(10px) 0 0;
        overflow-y: scroll;

        .one-record {
          border-bottom: unit(4px) solid #ddd;
          padding: unit(20px) unit(30px) unit(10px);

          div {
            font-size: unit(30px);
            margin-bottom: unit(10px);
          }
        }

        // .one-record:nth-last-of-type(1) {
        // border-bottom: none;
        // }
        .empty {
          width: 100%;
          text-align: center;

          .empty-img {
            width: unit(400px);
            height: unit(400px);
            margin: unit(100px) 0 unit(40px);
          }
        }
      }

      .btn-wrapper {
        width: 100%;
        height: unit(80px);
        display: flex;
        justify-content: space-around;
        align-items: center;
        position: absolute;
        bottom: 0;
        left: 0;
        border-top: 1px solid var(--gray);

        .btn {
          flex: 1;
          height: 100%;
          background: #fff var(--gray);
          border: none;
          outline: none;
          color: var(--gray);
        }

        .border-left {
          border-left: 1px solid var(--gray);
          color: var(--gold);
        }
      }
    }
  }
}
</style>